import React, {useState} from "react";
import SectionBox from "../../elements/SectionBox/SectionBox";
import TextField from "../../elements/TextField/TextField";
import Button from "../../elements/Button/Button";
import {useTranslation} from "react-i18next";
import {callAPI, isValidPassword} from "../../utils/utils";
import {useSnackbar} from "notistack";

const PasswordBox = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  
  const [ oldPassword, setOldPassword ] = useState("");
  const [ newPassword, setNewPassword ] = useState("");
  const [ newPasswordRepeat, setNewPasswordRepeat ] = useState("");
  
  const [ errorOldPassword, setErrorOldPassword ] = useState(false);
  const [ errorNewPassword, setErrorNewPassword ] = useState(false);
  const [ errorNewPasswordRepeat, setErrorNewPasswordRepeat ] = useState(false);

  const [ working, setWorking ] = useState(false);

  const resetErrors = () => {
    setErrorOldPassword(false);
    setErrorNewPassword(false);
    setErrorNewPasswordRepeat(false);
  }
  
  const handleSubmit = (e) => {
    e.preventDefault();

    if (oldPassword === "") {
      setErrorOldPassword(true);
      return;
    }

    if (!isValidPassword(newPassword)) {
      setErrorNewPassword(true);
      return;
    }

    if (newPassword !== newPasswordRepeat) {
      setErrorNewPasswordRepeat(true);
      return;
    }

    setWorking(true);

    callAPI("password/update", "POST", {oldPassword: oldPassword, newPassword: newPassword}).then(() => {
      enqueueSnackbar(t("PasswordBox.SaveSuccess"), {variant:'success'});
      setWorking(false);
    }).catch(() => {
      enqueueSnackbar(t("PasswordBox.SaveError"), {variant:'error'});
      setWorking(false);
      setErrorOldPassword(true);
    });
  }

  return (
    <SectionBox headline={"PasswordBox.Headline"} info={"PasswordBox.InfoText"} width={1000}>
      <form onSubmit={handleSubmit} style={{maxWidth:600}}>
        <div>
          <TextField
            id="oldPassword"
            label={t("PasswordBox.OldPassword")}
            onChange={(e) => {setOldPassword(e.target.value);}}
            onFocus={resetErrors}
            type="password"
            required
            helperText={errorOldPassword ? t("PasswordBox.IncorrectError") : " "}
            error={errorOldPassword}
          />
        </div>
        <TextField
          id="newPassword"
          label={t("PasswordBox.NewPassword")}
          onChange={(e) => {setNewPassword(e.target.value);}}
          onFocus={resetErrors}
          type="password"
          required
          helperText={errorNewPassword ? t("PasswordBox.NewPasswordError") : " "}
          error={errorNewPassword}
        />
        <TextField
          id="newPasswordRepeat"
          label={t("PasswordBox.NewPasswordRepeat")}
          onChange={(e) => {setNewPasswordRepeat(e.target.value);}}
          onFocus={resetErrors}
          type="password"
          required
          helperText={errorNewPasswordRepeat ? t("PasswordBox.RepeatError") : " "}
          error={errorNewPasswordRepeat}
        />
        <div>
          <Button
            type="submit"
            size="large"
            variant="contained"
            color="primary"
            working={working}
            className="submit"
          >
            {t("PasswordBox.Submit")}
          </Button>
        </div>
      </form>
    </SectionBox>
  );
}

export default PasswordBox;